import * as React from 'react';
import { FC, useMemo } from 'react';

import useMediaQuery from 'hooks/use-media-query';

import {
  METER_DESKTOP_HEIGHT,
  METER_DESKTOP_WIDTH,
  METER_DIAMETER_WIDTH_ADJUSTMENT,
  METER_HEIGHT,
  METER_STROKE_DESKTOP_WIDTH,
  METER_STROKE_WIDTH,
  METER_WIDTH,
} from './constants';
import { MeterIconInnerWrapper, MeterIconWrapper } from './loyalty-points-meter-widget.styled';
import { PointsIcon } from './points-icon';
import { IMeterIcon } from './types';

const START_ANGLE = 90;
const FULL_ANGLE = 270;
const ICON_OFFSET = 5;

export const MeterIcon: FC<IMeterIcon> = ({ progress }) => {
  const isDesktop = useMediaQuery('desktop');
  const width = isDesktop ? METER_DESKTOP_WIDTH : METER_WIDTH;
  const height = isDesktop ? METER_DESKTOP_HEIGHT : METER_HEIGHT;
  const diameter = width - METER_DIAMETER_WIDTH_ADJUSTMENT;
  const strokeWidth = isDesktop ? METER_STROKE_DESKTOP_WIDTH : METER_STROKE_WIDTH;
  const radius = (diameter - strokeWidth) * 0.5;
  const wrapperRotation = useMemo(() => {
    if (progress === 0) {
      return START_ANGLE + ICON_OFFSET;
    }
    return Math.min(
      FULL_ANGLE * (progress / 100) + START_ANGLE + ICON_OFFSET,
      FULL_ANGLE + START_ANGLE
    );
  }, [progress]);
  const iconRotation = 360 - 45 - wrapperRotation;
  const iconScale = isDesktop ? 1.85 : 1.4;

  return (
    <MeterIconWrapper style={{ width, height }}>
      <MeterIconInnerWrapper
        style={{
          transform: `rotate(${wrapperRotation}deg) translate(${radius}px) scale(${iconScale})`,
        }}
      >
        <PointsIcon
          style={{
            transform: `rotate(${iconRotation}deg)`,
            transition: '2s ease',
          }}
        />
      </MeterIconInnerWrapper>
    </MeterIconWrapper>
  );
};
